import criteo from "web/script/embedded/criteo";
import criteo_fr from "web/script/embedded/criteo_fr";
import environment from "web/script/modules/environment";
import browser from "web/script/utils/browser";

const COUNTRY_ACCOUNTS_MAP = {
    US: "US",
    GB: "GB",
    AL: "EU",
    AD: "EU",
    AM: "EU",
    AZ: "EU",
    BY: "EU",
    BE: "BE",
    BA: "EU",
    BG: "EU",
    HR: "EU",
    CY: "EU",
    CZ: "EU",
    DK: "EU",
    EE: "EU",
    FI: "EU",
    FR: "FR",
    FX: "EU",
    GE: "EU",
    DE: "DE",
    GR: "EU",
    HU: "EU",
    IS: "EU",
    IE: "EU",
    IT: "IT",
    LV: "EU",
    LI: "EU",
    LT: "EU",
    LU: "EU",
    MK: "EU",
    MT: "EU",
    MD: "EU",
    MC: "EU",
    ME: "EU",
    NL: "NL",
    AN: "EU",
    NO: "EU",
    PL: "EU",
    PT: "EU",
    RO: "EU",
    RU: "EU",
    SM: "EU",
    RS: "EU",
    SK: "EU",
    SI: "EU",
    ES: "ES",
    SE: "EU",
    CH: "CH",
    TR: "EU",
    UA: "EU",
    VA: "EU",
    AT: "AT",
    AU: "AU",
    CA: "CA",
};

const ACCOUNTS = {
    US: 55622,
    GB: 58186,
    EU: 30089,
    DE: 70989,
    IT: 70923,
    ES: 70927,
    AU: 70819,
    CA: 70818,
    NL: 70817,
    FR: 36542,
    AT: 74428,
    BE: 74430,
    CH: 74429,
    ROW: 36541,
};

const USER_SEGMENTS = {
    GB: {
        "Google-PLA-CSS": "1",
        "Bing-PLA": "2",
    },
    US: {
        "Bing-PLA": "1",
    },
};

/**
 * Get the custom Criteo viewport types.
 */
function getCriteoViewport() {
    switch (browser.getViewport()) {
        case browser.VIEWPORTS.MOBILE:
            return "m";
        case browser.VIEWPORTS.TABLET:
            return "t";
        case browser.VIEWPORTS.DESKTOP:
            return "d";
        default:
            return "";
    }
}

function getItem(event) {
    return {
        id: event.data.label,
        price: event.data.customData.sale_price,
        quantity: "1",
    };
}

export default {
    send(data) {
        // filter out only the events for page views in the US or lead events
        const events = data.reduce((prev, curr) => {
            if (
                curr.type === "page_view" ||
                curr.data.action === "lead" ||
                curr.data.action === "lead_sold_out" ||
                curr.type === "criteo_event"
            ) {
                prev.push(curr);
            }
            return prev;
        }, []);

        const userId = environment.get("userId");
        const country = environment.get("country");
        const language = environment.get("language");

        const region = COUNTRY_ACCOUNTS_MAP[country] || "ROW";
        const account = ACCOUNTS[region];

        // https://jira.lystit.com/browse/PAID-2237, temporary solution for BE
        if (country == "BE" && (language == null || !language.startsWith("nl"))) {
            return Promise.resolve();
        }

        // iterate over the events and send them to Criteo
        events.forEach((event) => {
            let criteoEvent;
            if (event.data.customData && event.data.customData.isCssLead) {
                criteoEvent = { event: "viewBasket", item: [getItem(event)] };
                const userSegments = USER_SEGMENTS[country] || {};
                const atcGrouping = event.data.customData.atc_grouping;
                if (atcGrouping in userSegments) {
                    criteoEvent["user_segment"] = userSegments[atcGrouping];
                }
            } else if (event.data.action === "lead" || event.data.action === "lead_sold_out") {
                const transactionID = event.data.session_id + (region === "GB" ? "-aff" : "");
                // https://jira.lystit.com/browse/AT-997 - more info on what to send to criteo
                if (environment.get("trafficSource") != "criteo") {
                    criteoEvent = { event: "viewBasket", item: [getItem(event)] };
                } else {
                    criteoEvent = {
                        event: "trackTransaction",
                        id: transactionID,
                        item: [getItem(event)],
                    };
                }
            } else if (
                event.data.page_type === "product" ||
                event.data.page_type === "product_overlay"
            ) {
                if (userId && event.data.product_is_icon) {
                    return Promise.resolve();
                }
                criteoEvent = { event: "viewItem", item: event.data.product_id };
            } else if (event.data.eventName === "criteo_product_ids") {
                criteoEvent = { event: "viewList", item: event.data.customData.ids };
            } else if (event.data.eventName === "criteo_cart_items") {
                criteoEvent = { event: "viewBasket", item: event.data.customData.cartItems };
            } else if (event.data.page_type === "homepage") {
                criteoEvent = { event: "viewHome" };
            }
            if (criteoEvent) {
                // Temporarily testing a new tag on the French market
                if (window.Lyst.environment.country === "FR") {
                    criteo_fr(
                        { event: "setAccount", account },
                        { event: "setSiteType", type: getCriteoViewport() },
                        { event: "setEmail", email: "" },
                        criteoEvent
                        // Add manualFlush and flushEvents events in case we want to send
                        // multiple events to different pixels.
                    );
                } else {
                    criteo(
                        { event: "setAccount", account },
                        { event: "setSiteType", type: getCriteoViewport() },
                        { event: "setEmail", email: "" },
                        criteoEvent
                        // Add manualFlush and flushEvents events in case we want to send
                        // multiple events to different pixels.
                    );
                }
            }
        });
        // no way of waiting for this to be done
        return Promise.resolve();
    },
};
